import modal from './modal';
import bind from './bind';

export default (editor, opts = {}) => {
    const $ = editor.$;
    const pfx = editor.getConfig().stylePrefix;
    const mdlClass = `${pfx}mdl-dialog-wx`;
    let primaryEl = '';
    let menusEl;
    const domEl = $(`#${pfx}mdl-website`);
    const menus = ['Save', 'Preview', 'View Published Site', '', 'Theme Manager', ['Site History'],
        '', 'Share Website', 'Delete Website', '', 'Back to Dashboard'
    ];

    menus.forEach((menu, i) => {
        let premium;
        typeof menu === 'object' && (menu = menu[0]) && (premium = 1);
        primaryEl += `<div data-filter="${menu}">
                ${++i !== menus.length ? `${menu}` : `<b>${menu}</b>`}
                ${premium ? ` <i class="fa fa-lock"></i>` : ''}
            </div>`
    });
    menusEl = domEl.length ? domEl :
        $(`<div id="${pfx}mdl-website" class="${pfx}mdl-options-container ${pfx}fadein">
            <div class="${pfx}mdl-options-primary">${primaryEl}</div>
            <div class="${pfx}mdl-illustration"></div>
        </div>`);

    !domEl.length && bind(pfx, menusEl, {
        editor,
        id: 'website',
        ...opts
    });

    modal(editor, mdlClass, 'Website', menusEl.get(0));
};